<!--2020/05/25 lqz-->
<template>
  <div class="ccui-home-index">
    <div class="emc-container">
      <el-tabs v-model="activeName">
        <el-tab-pane lazy :label="mallGoodsLabel" name="first">
          <mallGoods
            v-if="activeName === 'first'"
            ref="mallGoods"
            @getCartNum="getCartNum"
          ></mallGoods>
        </el-tab-pane>
        <el-tab-pane lazy :label="inquiryPriceGoodsLabel" name="second">
          <inquiryPriceGoods
            v-if="activeName === 'second'"
            ref="inquiryPriceGoods"
          ></inquiryPriceGoods>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import inquiryPriceGoods from "./inquiry-price-goods.vue";
import mallGoods from "./mall-goods.vue";
export default {
  name: "emc-home",
  components: { inquiryPriceGoods, mallGoods },
  computed: {
    mallGoodsLabel() {
      if (this.activeName === "first") {
        return `商城商品(${this.emcGoodsNum})`;
      } else {
        return `商城商品`;
      }
    },
    inquiryPriceGoodsLabel() {
      if (this.activeName === "second") {
        return `询/竞价商品(${this.emcGoodsNum})`;
      } else {
        return `询/竞价商品`;
      }
    }
  },
  data() {
    return {
      activeName: "",
      emcGoodsNum: 0
    };
  },
  created() {
    if (this.$route.query.cartType == "inquiry") {
      this.activeName = "second";
    } else {
      this.activeName = "first";
    }
  },
  methods: {
    getCartNum(num) {
      this.emcGoodsNum = num;
    }
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScrollx, true);
  }
};
</script>
<style lang="scss" scoped>
.emc-container /deep/ .emc-container {
  padding: 0;
  margin: 0;
}
.row {
  // display: flex;
  // justify-content: space-between;
}
.flex {
  display: flex;
  float: right;
  padding-right: 21px;
}
.invoiceSubject {
  float: left;
  max-width: 300px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.icon-shopingName {
  // width: 51px;
  height: 18px;
  line-height: 18px;
  text-align: center;
  background: #ff142f;
  border-radius: 9px;
  color: #fff;
  margin-right: 5px;
  font-size: 12px;
  padding: 0px 7px;
  display: inline-block;
  float: left;
  margin-top: 10px;
}
.shopName {
  display: block;
  max-width: 155px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
  float: left;
}
.low-price-label {
  border-radius: 4px;
  border: 1px solid #34ac2c;
  font-size: 12px;
  padding: 1px 6px;
  color: #34ac2c;
  user-select: none;
  // margin-left: 15px;
  // margin-right: 10px;
}
</style>
